import { coreApi } from '@cp/shared/api/core';
import { apiRouteMethodDict } from '@common/api/routeMethod';
import { ApiRoute } from '@common/api/route';
import { generateApiUrl } from '@common/api/configure';
import { ApiRouteBody } from '@common/api/routeBody';

export const clientTrainingApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    startTraining: builder.mutation<void, void>({
      query: () => ({
        method: apiRouteMethodDict[ApiRoute.ClientTrainingStart],
        url: generateApiUrl(ApiRoute.ClientTrainingStart),
      }),
    }),

    finishTraining: builder.mutation<void, ApiRouteBody[ApiRoute.ClientTrainingFinish]>({
      query: (body) => ({
        method: apiRouteMethodDict[ApiRoute.ClientTrainingFinish],
        url: generateApiUrl(ApiRoute.ClientTrainingFinish),
        body,
      }),
    }),
  }),
});
